import { z } from "zod";

export const StatementOfHealthStateSchema = z.object({
    application: z
        .object({
            state: z.string(),
            hasUsedNicotineLastYear: z.boolean(),
        })
        .nullable(),
});
